import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { OpenSnackbar } from '../actions/notification.actions';
import { NotificationsComponent } from '../components/notifications/notifications.component';
import { ActivityLogService } from '../services/activity-log.service';
import { RouteContextService } from '../services/route-context.service';

@Injectable()
export class NotificationEffects {
  constructor(
    private actions$: Actions,
    private snackBar: MatSnackBar,
    private activityLog: ActivityLogService,
    private routeContext: RouteContextService,
  ) {}

  openSnackBar$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OpenSnackbar),
        map((snackbar) => {
          const timestamp = new Date().toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
          });
          const detailsWithTime = snackbar.details
            ? `${timestamp} • ${snackbar.details}`
            : timestamp;

          this.snackBar.openFromComponent(NotificationsComponent, {
            data: {
              message: snackbar.message,
              details: detailsWithTime,
              icon: snackbar.icon,
              panelClass: snackbar.panelClass,
              copyValue: snackbar.copyValue,
            },
            duration: 5000,
            verticalPosition: 'top',
            panelClass: [snackbar.panelClass],
          });

          const isSuccess = snackbar.panelClass === 'success-snackbar';
          const action = this.detectAction(snackbar.message);

          this.activityLog.addEntry(
            isSuccess ? 'success' : 'error',
            action,
            snackbar.message,
            snackbar.details,
            snackbar.icon,
            snackbar.copyValue,
            this.routeContext.currentModule || undefined,
          );
        }),
      ),
    { dispatch: false },
  );

  private detectAction(message: string): 'create' | 'update' | 'delete' | 'action' {
    const lower = message.toLowerCase();
    if (
      lower.includes('creat') ||
      lower.includes('assign') ||
      lower.includes('add') ||
      lower.includes('new')
    ) {
      return 'create';
    }
    if (
      lower.includes('delet') ||
      lower.includes('remov') ||
      lower.includes('deactivat') ||
      lower.includes('destroy') ||
      lower.includes('lost')
    ) {
      return 'delete';
    }
    if (
      lower.includes('updat') ||
      lower.includes('edit') ||
      lower.includes('sav') ||
      lower.includes('activat') ||
      lower.includes('chang')
    ) {
      return 'update';
    }
    return 'action';
  }
}
